export enum CreateSignStep {
  LOCATION = 0,
  SUPPORT = 1,
  GROUP = 2,
  SIGN = 3,
  ADD_GROUP = 4,
  ADD_SIGN = 5,
}
